
export default function Layout({ children, current, nav, width }) {

    

    // recent - // * burger menu
    
    if(width < 768) {
        return (
            <div id="mobile-layout">
                <div id="mobile-recent-orders">
                    {children}
                </div>
                <div id="mobile-nav-wrapper">
                    {nav}
                </div>
            </div>
        ) 
    }

    // nav - recent

    if(width >= 768 && width < 992) {
        return (
            <div id="tablet-layout">
                <div id="nav-wrapper">
                    {nav}
                </div>
                <div id="recent-orders">
                    {children}
                </div>
            </div>
        )
    }

    // nav - recent - active

    return (
        <div id="pc-layout">
            <div id="nav-wrapper">
                {nav}
            </div>
            <div id="recent-orders">
                {children}
            </div>
            <div id="curently-active">
                {current}
            </div>
        </div>
    )
}